import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram, faTwitter, faYoutube, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom'
import './Footer.css'
import { faEarth, faIndianRupeeSign } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    const zomatoLogo =
        "https://b.zmtcdn.com/web_assets/b40b97e677bc7b2ca77c58c61db266fe1603954218.png";
    const playStoreLogo = "https://www.zomato.com/deliver-food/images/SocialIcons/google_play.png"
    const appleStoreLogo = "https://w7.pngwing.com/pngs/314/368/png-transparent-itunes-app-store-apple-logo-apple-text-rectangle-logo.png"
    return (
        <>
            <div className="container-fluid footer mt-5  pt-5">
                <div className="container footer-content">
                    <div className="row">
                        <div className="footer-logo-country d-flex">
                            <img src={zomatoLogo} alt="" srcset="" className='mb-5 ml-4' />
                            <div className="country-explore">
                                <button className='footer-btn footer-2'>  <FontAwesomeIcon className="icon-btn" icon={faIndianRupeeSign} />India</button>
                                <button className='footer-btn footer-1'> <FontAwesomeIcon className="icon-btn" icon={faEarth} />Explore</button>
                            </div>

                        </div>
                        <div className="container wrapper-footer d-flex justify-evenly align-center">
                            <ul className='col-2 footer-ul'>
                                <li className='footer-li'>
                                    <Link className="link-foot head-foot">ABOUT ZOMATO</Link>
                                    <Link className="link-foot">Who we are</Link>
                                    <Link className="link-foot">blog</Link>
                                    <Link className="link-foot">work with us</Link>
                                    <Link className="link-foot">investor relations</Link>
                                    <Link className="link-foot">report fraud</Link>
                                    <Link className="link-foot">contact us</Link>
                                </li>
                            </ul>
                            <ul className='col-2 footer-ul'>
                                <li className='footer-li'>
                                    <Link className="link-foot head-foot">Zomatoverse</Link>
                                    <Link className="link-foot">Zomato</Link>
                                    <Link className="link-foot">Blinkit</Link>
                                    <Link className="link-foot">Feeding india</Link>
                                    <Link className="link-foot">Hyperpure</Link>
                                    <Link className="link-foot">Zomaland</Link>

                                </li>
                            </ul> <ul className='col-2 footer-ul'>
                                <li className='footer-li'>
                                    <Link className="link-foot head-foot">For Restuarents</Link>
                                    <Link className="link-foot">Partner With Us</Link>
                                    <Link className="link-foot">Apps For You</Link>
                                    <Link className="link-foot pt-3 head-foot">For Enterprices</Link>
                                    <Link className="link-foot">Zomato For Enterprice</Link>
                                </li>
                            </ul>
                            <ul className='col-2 footer-ul'>
                                <li className='footer-li'>
                                    <Link className="link-foot head-foot">LEARN MORE</Link>
                                    <Link className="link-foot">Privacy</Link>
                                    <Link className="link-foot">Security</Link>
                                    <Link className="link-foot">Terms</Link>
                                    <Link className="link-foot">Sitemap</Link>
                                </li>
                            </ul>
                            <ul className='col-2 footer-ul'>
                                <li className='footer-li'>
                                    <Link className="link-foot head-foot">Social Links</Link>
                                    <div className="social-links d-flex align-center">
                                        <FontAwesomeIcon className="icon" icon={faLinkedin} />
                                        <FontAwesomeIcon className="icon" icon={faInstagram} />
                                        <FontAwesomeIcon className="icon" icon={faTwitter} />
                                        <FontAwesomeIcon className="icon" icon={faYoutube} />
                                        <FontAwesomeIcon className="icon" icon={faFacebook} />
                                    </div>
                                    <Link className="link-foot"><img src={playStoreLogo} alt="playStoreLogo" /></Link>
                                    <Link className="link-foot"><img src={appleStoreLogo} alt="appleStoreLogo" /></Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <hr className='mt-4 br-footer' />
                    <p className='footer-end mt-5'>
                    By continuing past this page, you agree to our Terms of Service, Cookie Policy, Privacy Policy and Content Policies. All trademarks are properties of their respective owners.
                    <br /> 2008-2023 © Zomato™ Ltd. All rights reserved.
                    </p>
                </div>
            </div>
        </>
    )
}

export default Footer